// Pulls a human-readable message out of a graphql-request ClientError (our
// resolvers raise GraphQL::ExecutionError with a user-facing message), falling
// back to a generic string.
export function errorMessage(error: unknown): string {
  const anyErr = error as { response?: { errors?: Array<{ message?: string }> }; message?: string };
  const graphqlMessage = anyErr?.response?.errors?.[0]?.message;
  if (graphqlMessage) return graphqlMessage;
  if (anyErr?.message) return anyErr.message;
  return "Something went wrong. Please try again.";
}
